import { type Map, type PointLike } from "maplibre-gl";

/** クリックで詳細を開くレイヤー。描画順がクリックの優先順位にもなる。 */
export const INTERACTIVE_LAYER_METADATA = { interactive: true };

export const isTopmostInteractiveLayer = (
  map: Map,
  point: PointLike,
  layerId: string
): boolean => {
  const layers = map
    .getStyle()
    .layers.filter(
      (layer) =>
        (layer.metadata as { interactive?: boolean } | undefined)
          ?.interactive === true
    )
    .map((layer) => layer.id);
  const topFeature = map.queryRenderedFeatures(point, { layers })[0];
  return topFeature?.layer.id === layerId;
};
